// extracted by mini-css-extract-plugin
export var label = "_60-1";
export var reminder = "_60-0";